import React from "react";
import { Link } from "react-router-dom";
import MultiLingualContent from "../../languages/MultiLingualContent";
import { LazyLoadImage } from "react-lazy-load-image-component";
import amanita from "../../assets/images/amanit20.jpeg";
import newSpecies from "../../assets/articles/מינים שנבדקו גנטית ופורסמו לראשונה בישראל.docx";
import { Helmet } from "react-helmet";
import map from "../../assets/images/map.png";
import BackButton from "../backButton";
import instructions from "../../assets/articles/הנחיות להגשת פטריות שמפיניון לכלבים.docx";
import poisonous from "../../assets/articles/קישור-הרעלה מפטריות.pdf";
import poison from "../../assets/images/poison.jpg";
import flies from "../../assets/images/flies.jpeg";
import oznit10 from "../../assets/images/oznit10.jpeg";
import oznit20 from "../../assets/images/oznit20.jpeg";

const News = () => {
  return (
    <div className="section" id="news">
      <Helmet>
        <title>פטרידע - מה חדש?</title>
        <meta name="description" />
      </Helmet>
      <div className="about-wrapper inner-section">
        <BackButton path="/" />
        <h2>
          <MultiLingualContent contentID="news" />
        </h2>
        <h3>קטעי העבר של "מה חדש?":</h3>
        <br />
        <h4> 1 - פתיח לנושא</h4>
        <p>כפתיח לנושא 'מה חדש' אתחיל ב'הכי ישן' בעולם הפטריות:</p>
        <p>
          בשנת 1753 גילה, תאר ופירסם Persoon את המין פינית מבאישה. ב1794 את הסוג
          פרגודית. ב1800 את האבקית, הקרישית והמצילה. בהמשך תאר עוד מינים רבים.
          בשנת 1806 גילה ותאר Kunze – את הסוג אורנייה. בהמשך השנים פורסמו עוד
          ועוד מינים.
        </p>
        <br />
        <br />
        <h4> 2 - פטריות לבקניות</h4>
        <p>
          תופעת הלבקנות/אלביניזם ידועה בכל מערכות החי והצומח כולל האדם והפטריות:
          זו הפרעה גנטית בה קיים חוסר בצבען/פיגמנט בשם מלנין והצבע לבן. הלבקנות
          אינה נחשבת מחלה ועוברת בתורשה.
        </p>
        <p>
          בעולם ובארץ ידועות תצפיות של מינים לבקנים, ולאחרונה נאספו לאוסף
          אוניברסיטת ת.א מספר מינים: בקבוצה של ישעורית אפורה נאספו מספר פרטים
          לבנים (י.גולדרינג) וביער אורנים נמצאה אורנייה מצויה (א.שדמי). כדי
          לוודא שאין זה מין בלתי מוכר – בדקנו ד.נ.א והזיהוי אומת. מסתבר שהגן
          האחראי על האלבינזם לא מתבטא בבדיקה רגילה.
        </p>
        <p>
          חשוב לציין שהסוג בשם לבקנית בארץ אינו נובע מהתופעה אלא מצבעו הלבן
          והצעתי התקבלה רישמית להחליפו בעברית ל'עציצית'. בעולם פורסמו כמה מאמרים
          של חוקרי פטריות-מאכל המנסים לטפח ולגדל מינים אלביניסטים, כדוגמת
          המאייטקה.
        </p>
        <br />
        <br />
        <h4> 3 - הצעה לקניית שי לחג</h4>
        <p>
          הפטריות יותר ויותר נכנסות לחיינו. הצורות, הצבעים והטעמים יפים ומגוונים
          והנה מתפתחות גם יצירות אומנות לשימושנו.
        </p>
        <p>
          מאיירת אתר הפטריות שלנו, ליטל פאר, מציירת ומפיקה מוצרים יפיפיים שתוכלו
          לרכוש, כמו: קלמר, תיק איפור, סימנייה, תיק צד ועוד. מצורף קישור לקטלוג:{" "}
          <a
            href="https://litalpeer-paintings.com/lilo-store/"
            target="_blank"
            rel="noreferrer"
          >
            https://litalpeer-paintings.com/lilo-store/
          </a>
        </p>
        <br />
        <br />
        <h4>4 - בול 'ישראלי' – זבובנית</h4>
        <p>
          בשרות הבולאי של דאר ישראל החליטו בשנת 2002 להנפיק סדרה של בולי פטריות,
          ועל כל בול כתוב שם הפטרייה ו" ישראל ". בין הבולים הכניסו גם בול של
          הפטרייה האדומה עם הנקודות הלבנות המפורסמת באירופה וכתבו לה שם ' אמנית
          הזבובים'. שלחנו תלונה לשרות הבולאי והסברנו שזו שגיאה גסה כי מין זה לא
          היה ולא יהיה בישראל.
        </p>
        <p>נחשו מה הייתה התשובה שלהם... "אבל היא יפה ".</p>
        <div className="informationImages">
          <div className="imgWrapper">
            <LazyLoadImage src={amanita} alt="אמנית" />
          </div>
        </div>
        <br />
        <br />
        <h4>5 - זיהוי וקביעת הסוגים והמינים בפטריות הארץ</h4>
        <p>
          זיהוי מיני פטריות בישראל סבל שנים רבות מאופן הבדיקות שהתבסס בעקר על
          צורות מורפולוגיות של גופי הפרי והנבגים. המגדירים בספרות התבססו על
          צורות הנבגים במבט דרך עדשות המיקרוסקופ, על מידות וצבעים של הרגל
          והכובע.
        </p>
        <p>
          עתה, שנת 2025, אנו נמצאים בעידן חדש בו הזיהוי והשייכות הטקסונומית
          מתבססים על עבודת מעבדה. נעשות בדיקות מולקולריות ואת הקביעה מבטא הריצוף
          הגנטי - הד.נ.א.
        </p>
        <p>
          דוגמא לבדיקות מעבדה ופרסום התוצאות של מינים שטרם פורסמו בישראל - ניתן
          לקרוא במאמרים המצורפים, ממוזיאון הטבע באוניברסיטת תל אביב וממכללת תל
          חי:
        </p>
        <br />
        1){" "}
        <a
          href="https://www.mdpi.com/2309-608X/11/6/414"
          target="_blank"
          rel="noreferrer"
        >
          Pezizales in Israel
        </a>
        <br />
        <br />
        2){" "}
        <a
          href="https://brill.com/view/journals/ijps/72/1-2/article-p57_6.xml?srsltid=AfmBOorvux7nUS0PZwMGEO1oBX98NGxzcI1xUWw5C1WGZZuwTgyfSLfX"
          target="_blank"
          rel="noreferrer"
        >
          New records of Macrofungi species in Israel
        </a>
        <br />
        <br />
        3){" "}
        <Link to={newSpecies} target="_blank" download>
          <MultiLingualContent contentID="newSpeciesInIsrael" />
        </Link>
        <br />
        <br />
        <h4>6 - תחזית מטאורולוגית לחודשים נובמבר 2025 עד פברואר 2026</h4>
        <p>
          על פי ממוצע האנסמבל של כלל המודלים העונתיים (מודלים עם זמן התחלתי של 1
          באוקטובר 2025). בתחילת עונת המשקעים, חודשים נובמבר 2025 עד ינואר 2026,
          כמויות הגשם תהיינה באופן יחסי הרבה מתחת לממוצע הרב שנתי של התקופה
          1993-2016.
        </p>
        <p>פורסם ע"י:</p>
        <p>ד"ר עמיר גבעתי וד"ר יצחק כרמונה</p>
        <p>19/10/2025 08:33</p>
        <br />
        <div className="about-map-wrapper">
          <img src={map} alt="" />
          <p>
            כמויות הגשם באחוזים לחודשים נובמבר, דצמבר וינואר 25/26 (NDJ)
            האנומליה היא ביחס לתקופה 1993-2016. (OND2025)
          </p>
        </div>
        <br />
        <br />
        <h4>7 - האם מותר להאכיל כלבים בפטריות ?</h4>
        <p>
          לא כל הפטריות בטוחות לצריכה עבור כלבים. ממליצים על מספר סוגי פטריות
          שנחשבות בטוחות ומזינות במיוחד. פטריות שמפניון, פורטובלו ושיטאקה הן
          אפשרויות מצוינות. הן עשירות בחומרים מזינים ובטוחות לצריכה כאשר הן
          מבושלות כראוי.
        </p>
        <br />
        <Link
          to={instructions}
          target="_blank"
          download
          alt="קובץ להורדה - הנחיות להגשת פטריות שמפיניון לכלבים"
        >
          <MultiLingualContent contentID="importanceAndRoleLink4" />
        </Link>
        <br />
        <br />
        <h4>8 - זהירות מהרעלה !</h4>
        <p>
          דצמבר 2025 , הגשם בא בשיא המרץ, הפטריות צצות במלוא הדרן והסלים מתמלאים
          בדרכן לצלחות. מספר חובבי הליקוט והזלילה עולה מיום ליום ומכאן המקרים של
          הרעלות מזנקים מעלה. כבר עתה, במחצית דצמבר, הופנו רבים לחדרי מיון,
          הסובלים מהקאות, שלשולים, פגיעה בכליות, בכבד ועוד.
        </p>
        <br />
        <p>
          מספיק שפטרייה אחת קטנה ממין מסוכן תכנס לסל עם פטריות הידועות בטיבן,
          וגופנו יפגע. מאוד קשה לשכנע את הציבור שרק לאחר לימוד מעמיק והכרות
          יסודית של מיני פטריות, תגיע העת לטפל בבישול ואכילה.
        </p>
        <p>
          על המקרה הרציני האחרון – ראו בכתבה שבקישור , באדיבות המרכז להרעלות
          בחיפה.
        </p>
        <div className="img-wrapper">
          <img src={poison} alt="Poison" />
        </div>
        <br />
        <div className="typeTable">
          <Link
            to={poisonous}
            target="_blank"
            download
            alt="קובץ להורדה - הרעלה מפטריות"
          >
            קובץ להורדה - הרעלה מפטריות
          </Link>
        </div>
        <br />
        <h4>9 - פטרייה משמשת מצע לגידול חרקים</h4>
        <p>
          אכילת פטריות מהטבע ומגידולים גוברת בתרבות שלנו ועולות שאלות מתחום
          צמחונות, טבעונות כשרות ומזיקים בגידול פטריות. מבין החרקים יש החיים
          במצע רבגוני, כולל פטריות, ויש שפטריות הן המצע היחידי בחייהם. לאחר הטלת
          הביצים בוקעים זחלים או רימות (לא תולעים !) הניזונים מבשר ומרקמות
          הפטרייה. שלב הבא יהיה הגולם וממנו יבקע הבוגר, ואז יוצא ועף להתחיל
          מחזור במצע חדש.
        </p>
        <br />
        <p>
          בעולם ידועים סוגי חיפושיות, עשים, זבובים ועוד, החיים וניזונים רק
          מתפטיר או גוף פרי של פטרייה. במוזיאון הטבע הכנסנו גושיות בוגרות לתוך
          בית גידול קטן ובקעו בו זבובים מהמין Muscina levida שלא היה ידוע
          בישראל, קרוב לזבוב הבית אך מעט שונה וגדול ממנו. בתוך הפטרייה קשתנית
          טבעתית זוהתה חיפושית מהסוג חדקונית. נמשיך ונבדוק מינים נוספים.
        </p>
        <div className="aboutImgWrapper">
          <LazyLoadImage src={flies} alt="אמנית" />
        </div>
        <h4>10 - חודש מרץ 2026 הקר והגשום</h4>
        <p>
          מזג האוויר בחודש מרץ הפתיע בתנאים החריגים מאז 40 שנה. כמות הגשם הייתה
          פי 2 מהממוצע השנתי והטמפרטורה נמוכה ב5 מעלות. לעומת תחילתו של האביב,
          היו חודשי החורף חמימים יחסית. הפטריות שגשגו בהעדר קרה וברדת גשמים
          מרובים. רשימת הסוגים והמינים הייתה שונה מזו שהכרנו, וכך זכינו למגוון
          מעניין של 'מקדימות' ו'מאחרות' במעורב.
        </p>
        <br />
        <p>
          הנגב, עד חלקו הדרומי ביותר, קיבל כמויות חריגות של גשם, הנחלים זרמו
          ונשטפו. התוצאה – צמיחה ופריחה שופעת של סוגים ומיני צמחים הממשיכים לתוך
          חודש אפריל. הפטריות, שחלקן התת-קרקעי היה רדום לאורך זמן, התעוררו
          וגידלו גופי פרי במגוון עשיר. בנוסף למינים המדבריים כמו כמהין, דפופית,
          סדנית ועוד, הופיעו גם מינים מהסוג פקועה, שברירית, דיואית וההפתעה לחג
          הפסח, לראשונה, אזנית על חרחבינה מגובבת, כזו שהכרנו בהר חרמון ב 2018.
          קיבלנו שיעור המבדיל את ממלכת הפטריות המגדלות גופי פרי במועדים על פי
          תנאי טמפרטורה, לחות ורטיבות, לעומת הצמחים הפורחים ומתרבים על פי מחזור
          השמש ואורך היום, בלוח השנה הלועזי.
        </p>
        <div className="aboutImgTextWrapperNews">
          <div className="aboutImgWrapper">
            <LazyLoadImage src={oznit10} alt="אמנית" className="smallImg" />
            <LazyLoadImage src={oznit20} alt="אמנית" className="smallImg" />
          </div>
          אזנית החרחבינה / הכלך בהר הנגב. דליה בונס
        </div>
      </div>
      <br />
    </div>
  );
};

export default News;
